const generateNodeHashKey = () => {
  return Math.random().toString(20).slice(2, 10);
};

export default generateNodeHashKey;
